export default __webpack_public_path__ + "static/media/treasure-box.576355cf.svg";